const PROTECTED_ROUTES = {
  ROOT: '/',
  DASHBOARD: '/dashboard',
  FACILITIES: '/facilities',
  FACILITIES_ADD: '/facilities/add',
  FACILITIES_UPDATE: '/facilities/update/:facilityId',
  FORBIDDEN: '/forbidden',
  GLOBAL_CONFIG:'/config',
  HL7HISTORY_LOGS: '/hl7history-logs',
  DICOM_LOGS: '/dicom-logs',
}

const PUBLIC_ROUTES = {
  LOGIN: '/login',
  SESSION_EXPIRED: '/session-expired',
};

const ROUTES = {
  PROTECTED: PROTECTED_ROUTES,
  PUBLIC: PUBLIC_ROUTES,
  ALL: { ...PUBLIC_ROUTES, ...PROTECTED_ROUTES }
}
export default ROUTES
